import Vue from 'vue';
import Component from 'vue-class-component';
import template from './social-login.html';
import './social-login.scss';
import {AuthSettings} from "../../../api/respresso-api";
import SettingsService from "../../../services/settings-service";

@Component({
	template: template,
})
export default class SocialLogin extends Vue {
	private authSettings: AuthSettings | null = null;
	private async mounted(): Promise<void> {
		this.authSettings = await SettingsService.getAuthSettingsAsync();
	}
}
